export default __webpack_public_path__ + "static/media/frame_29_delay-0.05s.963ea304.gif";